import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { useRecoilValue } from 'recoil';
import { getRecoil } from 'recoil-nexus';
import { appConfigAtomState } from '../../../state/reducerAtoms/app.atom';
import AppTable from '../../../components/table/index';

import { getCurrentFacilityURL } from '../../../helpers/helper.functions';
import { checkPermissions } from '../../../utils/permissions';
import { translateThis } from '../../../helpers/language.helper';
import { DATE_FORMAT } from '../../../constants';
import PageLayout from '../../app';
import AddAdminUserModal from './Add';

const AdminUsersList = () => {
    const appState = useRecoilValue(appConfigAtomState);
    const profile = appState?.profile || {};

    const facilityURL = getCurrentFacilityURL();
    const navigator = useNavigate();
    const [isOpen, setIsOpen] = useState(false);

    const tableColumns = [
        {
            title: `${translateThis('First Name')}`,
            dataIndex: 'name',
            key: 'name',
            onCell: () => ({
                style: { minWidth: 200 },
            }),
            width: 200,
            ellipsis: true,
        },
        {
            title: `${translateThis('Last Name')}`,
            dataIndex: 'lastName',
            key: 'lastName',
            width: 200,
            ellipsis: true,
        },
        {
            title: `${translateThis('Email')}`,
            dataIndex: 'email',
            key: 'email',
            width: 120,
            ellipsis: true,
            render: (text, record) => <>{(text || '')}</>
        },
        {
            title: `${translateThis('Accesses')}`,
            dataIndex: 'accesses',
            key: 'accesses',
            width: 120,
            ellipsis: true,
            render: (text, record) => <>{(text?.map((item) => item).join(', ') || '')}</>
        },
        {
            title: `${translateThis('Created at')}`,
            dataIndex: 'createdAt',
            key: 'createdAt',
            width: 130,
            ellipsis: true,
            render: (text, record) => dayjs(record?.createdAt).format(DATE_FORMAT)
        },

    ];

    const getExtraActionColumns = (record) => [
        {
            label: `${translateThis('View')}`,
            onClick: () => {
                navigator(`/${getCurrentFacilityURL()}/ai-development/view-module/${record.id}`, { state: { data: record } });
            }
        },
        {
            label: `${translateThis('Edit')}`,
            onClick: () => {
                navigator(`/${getCurrentFacilityURL()}/ai-development/edit-module/${record.id}`, { state: { data: record } });
            }
        },

    ];

    const [isRefreshData, setIsRefreshData] = useState(false);


    const refresh = () => {
        setIsRefreshData((prv) => !prv);
    }


    const getDataURL = () => `university/sub-admin`;


    return (
        <>
            {checkPermissions(profile, "See Admin Users") ?
                <>
                    <PageLayout
                        pageName={'Ai Modules'}
                        pageTitle={'Ai Modules'}
                        bodyClassName={`module-main-wrp`}
                        key={`${appState?.selectedLang}`}
                    >
                        <div className="container">
                            <div className="main-content-wrapper AI-module-list f-wrp">
                                {tableColumns.length > 0 ? null : <div className='module-create-box'>
                                    {
                                        checkPermissions(profile, "Create Admin User") &&
                                        <button className='create-module-btn' onClick={() => setIsOpen(true)}>{translateThis('Create a new Admin')}</button>
                                    }
                                </div>}

                                <div className="module-list-box appTable-list f-wrp">
                                    <div className='btn-header'>
                                        {
                                            checkPermissions(profile, "Create Admin User") &&
                                            <button className='create-module-btn' onClick={() => setIsOpen(true)}>{translateThis('Create a new Admin')}</button>
                                        }
                                    </div>

                                    <AppTable
                                        columns={tableColumns}
                                        dataURL={getDataURL()}
                                        isRefreshData
                                        isEditActionEnabled={false}
                                        isViewActionEnabled={false}
                                        isDeleteActionEnabled={false}
                                    // extraActions={getExtraActionColumns}
                                    // actionColumnSettings={{ width: 120 }}
                                    />
                                </div>
                            </div>

                        </div>
                    </PageLayout >
                    <AddAdminUserModal isOpen={isOpen} setIsOpen={setIsOpen} refresh={refresh} />
                </>
                :
                <PageLayout
                    pageName={'No Access'}
                    pageTitle={'No Access'}
                    bodyClassName={`module-main-wrp no-access-page`}
                    key={`${appState?.selectedLang}`}
                >
                    <div className="container">
                        <div className="main-content-wrapper AI-module-list f-wrp">
                            <div className='no-access-box'>
                                <div className='no-access-title'>
                                    <h2 style={{ color: '#fff', textAlign: 'center' }}>{translateThis('No Access')}</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </PageLayout>}
        </>
    )
}
AdminUsersList.propTypes = {}

export default AdminUsersList;
